// 7.1.13 ToObject(argument)
var defined = require('./$.defined');
module.exports = function(it){
  return Object(defined(it));
};


//////////////////
// WEBPACK FOOTER
// /Users/frontend-dev/Desktop/ESM/elit_stroy_front/~/babel-runtime/~/core-js/library/modules/$.to-object.js
// module id = 15
// module chunks = 0